var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Info.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Info = ({
  color = 'rgba(255, 255, 255, 0.5)',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_182_82523)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 10.5C2 6.084 5.584 2.5 10 2.5C14.416 2.5 18 6.084 18 10.5C18 14.916 14.416 18.5 10 18.5C5.584 18.5 2 14.916 2 10.5ZM10.8 6.5H9.20001V8.1H10.8V6.5ZM10.8 9.7H9.20001V14.5H10.8V9.7Z",
      fill: color
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_182_82523",
      children: /*#__PURE__*/_jsx("rect", {
        width: "20",
        height: "20",
        fill: color,
        transform: "translate(0 0.5)"
      })
    })
  })]
});